import * as actionTypes from "./actionTypes";
import {collections,documents,constants} from "../../firebase/firestoreNameSpaces";
import {firebase} from "../../firebase/index"
import {generateUniqueId} from "../utility"

const checkSubcategoryExist = (subcategories,newsubcategoryname)=>{
  let exists = subcategories.filter(sObj=>sObj.name===newsubcategoryname).length
  if(exists){
      return true
  }else{
      return false
  }
}

export const onAddSubCategory = (newSubCategoryObj,category) => {
  
  return async(dispatch,getState) => {
  
    try{
      
      
  
      let newSubcategory = newSubCategoryObj.newSubCategoryName;
     
      //from metadata
          //############################################

          //Avoid Subcategory duplicates
          if (category.subcategories) {
            let exists = checkSubcategoryExist(category.subcategories,newSubcategory)
            if (exists) {
              return alert("Sub-Category already exists. Please Try some other name");
            }
          }
          dispatch({ 
            type: actionTypes.UTILITY_CONTROLS,
            payload: { addSubCategoryBtnLoading: true },
          });
          
          let categoryId = category.id;
          const db = firebase.firestore();
          const batch = db.batch();
          let subcategoryId = db.collection(collections.CATEGORIES).doc().id+generateUniqueId(4)
          //Adding to array in metadata
          let c1 =  db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
            batch.set(c1,
              {
                [categoryId]: {
                  [constants.SUBCATEGORIES]: {
                      [subcategoryId]:newSubcategory
                  },
                },
              },
              { merge: true }
            );
          //let categoryId = db.collection(collections.CATEGORIES).doc().id;
          // Adding to categories collection

          let c2 =  db.collection(collections.CATEGORIES).doc(categoryId)
          batch.set(c2,{
            [constants.SUBCATEGORIES]: {
                [subcategoryId]:newSubcategory
            }
          },{merge:true})

            await batch.commit();
              dispatch({
                type: actionTypes.UTILITY_CONTROLS,
                payload: { addSubCategoryBtnLoading: false },
              });
            return alert("Subcategory Added Successfully...")
     }catch(error){
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { addSubCategoryBtnLoading: false },
        });
          return alert(error)
     }

  };
};
